import React, { useRef, useState } from 'react';
import { useOnClickOutside } from 'usehooks-ts';

import SortArrows from '@/assets/icons/SortArrows';
import useWerklijnenSubscription from '@/state/selectors/useWerklijnenSubscription';
import useClientState from '@/state/useClientState';

import styles from './SortMenu.module.css';

const SortMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const { sorteerWerklijnen } = useWerklijnenSubscription();
  const { werklijnSortering } = useClientState((state) => ({
    werklijnSortering: state.werklijnSortering,
  }));

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  useOnClickOutside(menuRef as React.RefObject<HTMLElement>, () => setIsOpen(false));

  const handleOptionClick = (option: 'eenheid' | 'uitloop' | 'inzetbaarheid' | 'treinnummer') => {
    sorteerWerklijnen(option);

    setIsOpen(false);
  };

  return (
    <div className={styles.sortMenuStyle} ref={menuRef}>
      <div className={`${styles.sortMenuButtonStyle} ${werklijnSortering === 'eenheid' ? '' : styles.activeDotStyle}`}>
        <SortArrows
          data-testid='sort-button'
          fill='var(--tractie-color-content-interactive-default)'
          onClick={toggleMenu}
          width='24px'
          height='24px'
          aria-hidden='true'
        />
      </div>
      {isOpen && (
        <ul className={styles.sortMenuOptionsStyle}>
          <li onClick={() => handleOptionClick('eenheid')} className={styles.sortMenuOptionStyle}>
            Eenheid
          </li>
          <li onClick={() => handleOptionClick('uitloop')} className={styles.sortMenuOptionStyle}>
            Uitloop
          </li>
          <li onClick={() => handleOptionClick('treinnummer')} className={styles.sortMenuOptionStyle}>
            Treinnummer
          </li>
          <li onClick={() => handleOptionClick('inzetbaarheid')} className={styles.sortMenuOptionStyle}>
            Inzetbaarheid
          </li>
        </ul>
      )}
    </div>
  );
};
export default SortMenu;
